import { render, staticRenderFns } from "./MoMHeatMap.vue?vue&type=template&id=4d56d00e&scoped=true&lang=pug"
import script from "./MoMHeatMap.vue?vue&type=script&lang=js"
export * from "./MoMHeatMap.vue?vue&type=script&lang=js"
import style0 from "./MoMHeatMap.vue?vue&type=style&index=0&id=4d56d00e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d56d00e",
  null
  
)

export default component.exports